class BrandScrollbar {
  constructor(nav, track) {
    this.nav = nav;
    this.track = track;
    this.thumb = track.querySelector('.brands-list__scrollbar-thumb');
    if (!this.thumb) return;
    this._bind();
  }

  _bind() {
    this._observer = new ResizeObserver(() => this._update());
    this._observer.observe(this.nav);
    this.nav.addEventListener('scroll', () => this._update(), { passive: true });
    this._update();
  }

  _update() {
    const w = this.nav.clientWidth;
    const total = this.nav.scrollWidth;
    if (total <= w) {
      this.track.classList.remove('is-visible');
      return;
    }
    this.track.classList.add('is-visible');
    const pct = w / total;
    const scrolledPct = this.nav.scrollLeft / (total - w);
    const thumbW = Math.max(pct * 100, 8);
    const offset = scrolledPct * (100 - thumbW);
    this.thumb.style.width = thumbW + '%';
    this.thumb.style.transform = 'translateX(' + Math.round(offset) + '%)';
  }
}

// Init
class BrandToggle {
  constructor(el) {
    this.wrap = el;
    this.btn = el.querySelector('.brands-list__toggle');
    this.idx = el.dataset.brandToggle;
    this.showMore = el.dataset.showMore;
    this.showLess = el.dataset.showLess;
    this.hidden = document.getElementById('brand-hidden-' + this.idx);
    if (!this.hidden || !this.btn) return;
    this.wrap.addEventListener('click', this._toggle.bind(this));
  }

  _toggle() {
    const open = this.hidden.classList.toggle('is-open');
    this.wrap.classList.toggle('is-open');
    this.btn.setAttribute('aria-expanded', open);
    this.btn.querySelector('span').textContent = open ? this.showLess : this.showMore;

    const headerH = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;

    if (open) {
      setTimeout(() => {
        const first = this.hidden.querySelector('a');
        if (first) {
          const top = first.getBoundingClientRect().top + window.pageYOffset - headerH - 16;
          window.scrollTo({ top, behavior: 'smooth' });
        }
      }, 150);
    } else {
      const block = this.wrap.closest('.brands-list__i');
      if (block) {
        const top = block.querySelector('.brands-list__title').getBoundingClientRect().top + window.pageYOffset - headerH - 16;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    }
  }
}

document.querySelectorAll('[data-brand-toggle]').forEach(el => new BrandToggle(el));

// Scrollbar
document.querySelectorAll('.brands-list__nav').forEach(nav => {
  const track = nav.nextElementSibling;
  if (track && track.classList.contains('brands-list__scrollbar-track')) {
    new BrandScrollbar(nav, track);
  }
});
